import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The three types of projects worth your time",
  "description": "",
  "published": "2011-04-18T00:00:00.000Z",
  "redirect_from": ["/blog/?p=1636"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Incredibly exciting to work on`}</p>
    <p>{`Changing the world / people crying to have it`}</p>
    <p>{`Pays money directly`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      